import { INCLUDE_STEPS } from '@/config/membershipTierWizardSteps'

const FEATURE_OF = Object.fromEntries(Object.entries(INCLUDE_STEPS).map(([feature, step]) => [step, feature]))

const stateOf = (row, { current, reached, feature }) => {
  if (current) return 'current'
  if (!reached) return feature ? 'added' : 'upcoming'
  return row.set ? 'done' : 'upcoming'
}

export const railRows = (rows, { currentKey, visited = new Set(), includeTitles = {}, editing = false }) => {
  const shownIndex = rows.findIndex(row => row.key === currentKey)
  const currentIndex = shownIndex === -1 ? rows.length : shownIndex
  return rows.map((row, index) => {
    const feature = editing ? null : FEATURE_OF[row.key]
    const reached = editing || visited.has(row.key) || index < currentIndex
    const state = stateOf(row, { current: row.key === currentKey, reached, feature })
    const earlierValid = rows.slice(0, index).every(earlier => earlier.valid)
    return {
      ...row,
      state,
      fromIncludes: Boolean(feature),
      addedBecause: feature ? includeTitles[feature] : null,
      jumpable: editing || state === 'done' || state === 'current' || earlierValid
    }
  })
}
